module.exports = __webpack_public_path__ + "img/hegzdb.01828b18.png";